// ReceivableDetailModal.tsx

import { Users } from 'lucide-react';

import FormModal from '../../../../components/Modals/FormModal';

import DetailHeaderSection from './sections/DetailHeaderSection';
import DetailCustomerSection from './sections/DetailCustomerSection';
import DetailFinancialSummarySection from './sections/DetailFinancialSummarySection';
import DetailDatesSection from './sections/DetailDatesSection';
import DetailPaymentHistorySection from './sections/DetailPaymentHistorySection';
import DetailNotesSection from './sections/DetailNotesSection';
import DetailTimelineSection from './sections/DetailTimelineSection';
import DetailOriginSection from './sections/DetailOriginSection';
import DetailProductsSection from './sections/DetailProductsSection';
import DetailActionsSection from './sections/DetailActionsSection';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ReceivableDetailModal = ({ isOpen, onClose }: Props) => {
  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle de Cuenta por Cobrar"
      maxWidth="max-w-5xl"
      overlayBg="black"
      zIndex="front"
    >
      <div className="space-y-6">

        {/* 🔹 ENCABEZADO */}
        <div className="-mx-5 -mt-6 flex items-center gap-3 bg-success/5 px-5 py-4">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-success text-white">
            <Users className="h-5 w-5" />
          </span>
          <div>
            <h3 className="font-semibold text-black dark:text-white">
              Cuenta por Cobrar
            </h3>
            <p className="text-sm text-body dark:text-bodydark2">
              Detalle completo del saldo pendiente del cliente
            </p>
          </div>
        </div>

        <DetailActionsSection />

        {/* 1. Resumen principal */}
        <DetailHeaderSection />

        {/* 2. Quién debe */}
        <DetailCustomerSection />

        {/* 3. De dónde nació la deuda */}
        <DetailOriginSection />

        {/* 4. Qué productos generaron la deuda */}
        <DetailProductsSection />

        {/* 5. Estado financiero actual */}
        <DetailFinancialSummarySection />

        {/* 6. Fechas clave */}
        <DetailDatesSection />

        {/* 7. Observaciones importantes */}
        <DetailNotesSection />

        {/* 8. Qué ha pasado en el tiempo */}
        <DetailTimelineSection />

        {/* 9. Pagos realizados */}
        <DetailPaymentHistorySection />
      </div>
    </FormModal>
  );
};

export default ReceivableDetailModal;
